import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOrcidComponent } from './simple-icons-orcid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOrcidComponent ],
    exports:      [ SimpleIconsOrcidComponent ],
    bootstrap:    []
})
export class SimpleIconsOrcidModule {}
